import { useState, useEffect } from 'react';
import { BXPCallingListsTable } from 'components/tables/BXPCallingListsTable';
import {
  fetchBXPCallingLists,
  BXPCallingList
} from 'services/hvaservicecampaign.service';

const BXPCallingListList: React.FC = () => {
  const [callingLists, setCallingLists] = useState<BXPCallingList[]>([]);
  const loadCallingLists = async (): Promise<void> => {
    try {
      const fetchedCallingLists = await fetchBXPCallingLists();
      setCallingLists(fetchedCallingLists);
    } catch (error) {
      console.error('Error loading calling lists:', error);
    }
  };

  useEffect(() => {
    loadCallingLists();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <BXPCallingListsTable
          callingLists={callingLists}
          onCallingListsChange={loadCallingLists}
        />
      </div>
    </div>
  );
};

export default BXPCallingListList;
